import { render, staticRenderFns } from "./MenuUp.vue?vue&type=template&id=52b567ec&"
import script from "./MenuUp.vue?vue&type=script&lang=js&"
export * from "./MenuUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports